import useSWR from "swr"
import dayjs from "dayjs"
// import { useNavigate } from "react-router-dom"
import { Search } from "lucide-react"
import { Input } from "../../components/ui/input"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table"
import { fetcher } from "../../util/axios"
import placeholder from "../../util/placeholder"
import PageSpinner from "../../components/PageSpinner"
import DataView from "../../components/DataView"
import { payoutConfig } from "../../constants/data-view-configs/payout-requests-config"
import { useCurrency } from "../../hooks/useCurrency"


export default function Payouts() {
    const [formatCurrency] = useCurrency()
    // const navigate = useNavigate();
    const { data, isLoading } = useSWR({ url: "fleet/payment-records" }, fetcher)
    const payouts: PayoutRequest[] = data?.data || [];

    // const handleDataViewClick = useCallback((data: any) => {
    //     navigate(`/payouts/${data.id}`)
    // }, [navigate])

    if (isLoading){
        return<PageSpinner/>   
    }

    return (
        <div className="h-full overflow-auto border rounded-lg">
            <div className="p-4 border-b">
                <div className="relative w-full">
                    <Input type="text" placeholder="Search" className="w-full pl-4 pr-10 py-2 border rounded-md" />
                    <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                </div>
            </div>
            {/* Vehicles Table for Medium & Large Screen */}
            <div className="hidden md:block">
                <Table>
                    <TableHeader>
                        <TableRow className="bg-white">
                            <TableHead className="font-semibold text-center">Receipt</TableHead>
                            <TableHead className="font-semibold text-center">Status</TableHead>
                            <TableHead className="font-semibold text-center">Date Created</TableHead>
                            <TableHead className="font-semibold text-center">Date Paid</TableHead>
                            <TableHead className="font-semibold text-center">Amount</TableHead>
                            {/* <TableHead className="font-semibold">Total earned</TableHead> */}
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {payouts?.map((payout) => (
                            <TableRow key={payout.id} className="border-t hover:bg-gray-50 cursor-pointer">
                                {payout.receiptImageUrl ? (
                                    <TableCell className="text-center">
                                        <div className="w-10 h-10 mx-auto border rounded flex items-center justify-center">
                                            <img
                                                src={payout.receiptImageUrl || placeholder}
                                                alt={"Payout Receipt"}
                                                width={30}
                                                height={30}
                                                className="object-contain"
                                            />
                                        </div>
                                    </TableCell>
                                ) : (<TableCell className="text-muted-foreground text-center">Not Available</TableCell>)}
                                <TableCell className="text-center">
                                    <span className={`font-semibold text-${payout?.status === "PAID" ? "blue" : "orange"}-600`}>
                                        {payout?.status}
                                    </span>
                                </TableCell>
                                <TableCell className="text-center">{dayjs(payout.createdAt).format("DD/MM/YYYY")}</TableCell>
                                <TableCell className="text-center">{payout.paidAt ? dayjs(payout.paidAt).format("DD/MM/YYYY") : "-"}</TableCell>
                                <TableCell className="text-center font-semibold">{formatCurrency(payout.amount)}</TableCell>
                                {/* <TableCell>{vehicle.totalTrips}</TableCell>
                                <TableCell className="text-orange-500">{formatCurrency(+vehicle.totalEarned)}</TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
            {/* Mobile Screen Cards */}
            <div className="md:hidden mt-4">
                <DataView
                    loading={isLoading}
                    records={payouts}
                    config={payoutConfig}
                    // onClick={handleDataViewClick}
                />
            </div>
        </div>
    )
}